import { render, staticRenderFns } from "./SelectCopy.vue?vue&type=template&id=c5012024&scoped=true"
import script from "./SelectCopy.vue?vue&type=script&lang=js"
export * from "./SelectCopy.vue?vue&type=script&lang=js"
import style0 from "./SelectCopy.vue?vue&type=style&index=0&id=c5012024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5012024",
  null
  
)

export default component.exports